module.exports = __webpack_public_path__ + "img/nodata@2x.b13905d5.png";